<script>
  import session from '@/services/session';

  export default {
    name: 'Company',

    props: {
      company: {
        type: String,
        required: true,
      },
    },

    created() {
      // @TODO Remove created after removeing all 'params.company_slug'
      // Updates the API Base URL to include the current Company
      session.defaults.params = { company_slug: this.company };
    },
  };
</script>

<template>
  <router-view />
</template>
